/** Gemini CLI's own list: google-gemini/gemini-cli docs/cli/model.md, fetched
 *  2026-09-24. No cache on disk to generate it from (unlike claude and codex),
 *  so it is copied from the doc and dated. Chat lists it behind a Connect chip;
 *  no adapter runs it yet. */
export const GEMINI_MODELS = ["gemini-3-pro-preview", "gemini-3-flash-preview", "gemini-2.5-pro", "gemini-2.5-flash"];
